module.exports = __webpack_public_path__ + "img/tips16.1474dbde.png";